import { Static, Type } from '@sinclair/typebox'

export const Connection = Type.Object({
    sourceId: Type.Optional(Type.String()),
    targetId: Type.Optional(Type.String()),
})

export type Connection = Static<typeof Connection>
